<template>
  <div class="report-push-container column">
    <div class="flex-1 overflow-y">
      <!--患者的症状方案列表-->
      <div class="symptom-list">
        <!-- 使用Treatment组件 -->
        <Treatment
          :isMobile="true"
          :treatmentList="treatmentList"
          :problemTextList="problemTextList"
        />
        <!-- 当没有数据时显示空状态 -->
        <div
          v-if="treatmentList.length === 0 && problemTextList.length === 0"
          class="no-data"
        >
          <div class="font-666">暂无治疗方案数据</div>
        </div>

        <!-- 常规版本报告 -->
        <div v-if="normalReportList.length > 0" class="report-group">
          <div class="report-group-title">常规版本报告</div>
          <div class="report-group-entry">
            创建入口：蓝莓象-患者管理-患者-口腔健康报告
          </div>

          <div
            v-for="(item, itemIndex) in normalReportList"
            :key="itemIndex"
            class="report-card"
          >
            <div class="report-card-row">
              <span class="report-card-label">报告ID：</span>
              <span class="report-card-value">{{ item.id }}</span>
            </div>
            <div class="report-card-row">
              <span class="report-card-label">报告更新：</span>
              <span class="report-card-value"
                >{{ item.updateUserName }} {{ item.updateTime }}</span
              >
            </div>
            <div class="report-card-row">
              <span class="report-card-label">报告门店：</span>
              <span class="report-card-value">{{ item.clinicName }}</span>
            </div>
            <div class="report-card-buttons">
              <div
                class="report-card-btn btn-preview"
                @click="onViewNormalReport(item)"
              >
                预览报告
              </div>
              <div
                class="report-card-btn btn-send"
                @click="onSendNormalReport(item)"
              >
                发送报告
              </div>
            </div>
          </div>
        </div>

        <!-- 藩后街专属报告 -->
        <div
          v-if="
            isFanHouJieCorp &&
            fanHouJieReport &&
            (treatmentList.length > 0 || problemTextList.length > 0)
          "
          class="report-group"
        >
          <div class="report-group-title">藩后街专属报告</div>
          <div class="report-group-entry">
            创建入口：蓝莓象-患者管理-患者-诊疗方案
          </div>

          <div class="report-card">
            <div class="report-card-row">
              <span class="report-card-label">报告更新：</span>
              <span class="report-card-value"
                >{{ fanHouJieReport.updateUserName }}
                {{ fanHouJieReport.updateTime }}</span
              >
            </div>
            <div class="report-card-buttons">
              <div
                class="report-card-btn btn-preview"
                @click="onViewFanHouJieReport"
              >
                预览报告
              </div>
              <div
                class="report-card-btn btn-send"
                @click="onSendFanHouJieReport"
              >
                发送报告
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadingStore } from "@/store/loading.js";
import { userStore } from "@/store/user.js";
import func from "@/util/func.js";
import { showDialog, showToast } from "vant";
import { getStore } from "@/util/store.js";
import crypto from "@/util/crypto.js";
import tool from "@/util/debounce.js";
import { isJuzi } from "@/util/platform.js";
import { useJuziSendStore } from "@/store/juzi/juziSend.js";

import {
  queryWeChatPatientDetails,
  getBoundPatientTreatmentPlan,
  getPatientOralReportListAll,
  getTreatmentPlanLatestUpdate,
} from "@/api/patient.js";
import {
  generateHealthReportPreviewPath,
  generateHealthReportShareInfo,
  buildShareVerificationPath,
  REPORT_VERIFY_TYPE,
} from "@/util/healthReport.js";

import HideMobile from "@/components/publick/hideMobile.vue";
import Treatment from "@/components/patient/treatment.vue";

// 藩后街专属报告仅对该企微号展示：长沙牙管家健康管理咨询有限公司未雨口腔门诊部
const FAN_HOU_JIE_CORP_ID = "ww1b24fa156ed02e21";

export default {
  name: "ReportPush",
  props: {
    // 患者ID
    patientId: {
      type: String,
      required: true,
    },
  },
  components: {
    HideMobile,
    Treatment,
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },
  data() {
    return {
      patientInfo: {},
      // 报告列表数据
      reportList: [],
      treatmentList: [], // 治疗方案列表数据
      problemTextList: [], //口内风险
      currentCorpId: "", // 当前登录的企微号
      // 常规版本报告列表
      normalReportList: [],
      // 藩后街专属报告（一个患者对应一个报告，无报告ID）
      fanHouJieReport: null,
      // 加载状态
      isLoading: false,
      // 消息有效期常量 - 48小时
      MSG_VALID_TIME: 48 * 60 * 60 * 1000,
    };
  },
  computed: {
    // 是否为藩后街专属企微号
    isFanHouJieCorp() {
      return this.currentCorpId === FAN_HOU_JIE_CORP_ID;
    },
  },
  mounted() {
    //获取当前登录的企微号
    const user = userStore();
    this.currentCorpId = user.corpId;

    //获取患者信息
    this.getParentInfo();

    //获取治疗方案
    this.getTreatmentPlan();

    //获取常规版本报告列表
    this.getNormalReportList();

    //藩后街专属企微号才需要获取藩后街专属报告列表
    if (this.isFanHouJieCorp) {
      this.getFanHouJieReportList();
    }
  },
  methods: {
    // 获取常规版本报告列表
    getNormalReportList() {
      const that = this;
      const subdata = {
        patientId: that.patientId,
        status: 1, //	报告状态(0-创建中 1-已发布)
      };

      getPatientOralReportListAll(subdata).then((res) => {
        const data = res.data.data || [];
        that.normalReportList = data;
      });
    },
    // 获取藩后街专属报告列表（仅藩后街专属企微号才会调用，一个患者对应一个报告，无报告ID）
    getFanHouJieReportList() {
      const that = this;
      const subdata = {
        patientId: that.patientId,
      };

      getTreatmentPlanLatestUpdate(subdata).then((res) => {
        const data = res.data.data;
        that.fanHouJieReport = data || null;
      });
    },
    getParentInfo() {
      //获取客户的信息
      let that = this;
      //获取患者信息
      let subdata = {
        patientId: that.patientId,
      };
      that.loading.showLoading();
      queryWeChatPatientDetails(subdata).then((res) => {
        that.loading.hideLoading();
        let { data } = res.data;
        that.patientInfo = data;
      });
    },
    getTreatmentPlan() {
      //获取治疗方案
      let that = this;
      const user = userStore();
      let { corpId, cusId } = user;
      const subdata = {
        corpId,
        cusId,
      };

      getBoundPatientTreatmentPlan(subdata).then((res) => {
        const data = res.data.data || [];
        const treatmentList = data.filter((item) => item.status !== 3) || [];
        const problemList = data.filter((item) => item.status === 3) || [];
        const problemTextList = [];

        problemList.forEach((item) => {
          //toothType	牙位类型(0-牙,1-全口,2-半口)
          if (item.toothType === 1) {
            problemTextList.push("全口-" + item.subDiagnosisName);
          } else {
            //选择了一个个的牙位
            problemTextList.push(
              item.fdiToothCodes + "-" + item.subDiagnosisName,
            );
          }
        });

        that.treatmentList = treatmentList;
        that.problemTextList = problemTextList;
      });
    },
    // 拉起小程序预览指定页面路径（常规报告、藩后街报告共用的小程序跳转逻辑）
    launchMiniprogramPreview(path) {
      const user = userStore();

      // 测试用
      //const appid = "wx358d4f9ee1ff58bd";

      const appid = user.wxAppId;

      console.log(path);

      // 检查是否配置了小程序appid
      if (func.isEmpty(appid)) {
        showDialog({
          title: "提示",
          message: "企微未绑定微信小程序",
          confirmButtonColor: "#28B8C3",
        });
        return;
      }

      // 橘子平台侧边栏环境不支持直接拉起小程序，需前置拦截提示
      if (isJuzi()) {
        showDialog({
          title: "提示",
          message: "外部平台不支持直接打开小程序预览",
          confirmButtonColor: "#28B8C3",
        });
        return;
      }

      user
        .getWxconfig(["launchMiniprogram"])
        .then(() => {
          wx.invoke(
            "launchMiniprogram",
            {
              appid: appid, // 需跳转的小程序appid
              path: path, // 所需跳转的小程序内页面路径及参数。非必填
            },
            function (res) {
              if (res.err_msg == "launchMiniprogram:ok") {
                // 正常
              } else {
                // 错误处理
              }
            },
          );
        })
        .catch((err) => {
          showDialog({
            title: "操作失败",
            message: err,
            confirmButtonColor: "#28B8C3",
          });
        });
    },
    // 预览常规版本报告（携带具体的报告ID，target为healthReport）
    onViewNormalReport: tool._debouncefont(function (item) {
      const path = generateHealthReportPreviewPath(this.patientId, item.id);
      this.launchMiniprogramPreview(path);
    }, 1000),
    // 预览藩后街专属报告（无报告ID，不传target，走健康档案默认页面）
    onViewFanHouJieReport: tool._debouncefont(function () {
      const path = buildShareVerificationPath({
        type: REPORT_VERIFY_TYPE.STAFF, // 验证类型：员工预览
        patient_id: this.patientId, // 患者ID
      });

      this.launchMiniprogramPreview(path);
    }, 1000),
    // 根据状态值获取对应的CSS类名
    getStatusClass(status) {
      // 根据status值返回对应的class名称
      // 0: 未治疗 -> status1
      // 1: 其他状态 -> status2
      // 2: 其他状态 -> status3
      // 3: 未制定 -> status3 (根据示例数据)
      const statusMap = {
        0: "status1",
        1: "status2",
        2: "status2",
        3: "status3",
      };
      return statusMap[status] || "status1"; // 默认返回status1
    },
    // 发送常规版本报告（携带具体的报告ID，target为healthReport）
    onSendNormalReport: tool._debouncefont(function (item) {
      const user = userStore();

      // 检查患者是否有手机号码
      if (func.isEmpty(this.patientInfo.contactNo1)) {
        showToast("该患者无手机号码，请完善患者信息后再发送报告");
        return;
      }

      const shareInfo = generateHealthReportShareInfo({
        patientId: this.patientId,
        reportId: item.id,
        clinicId: user.userInfo.detail.clinic_id,
        tenantId: user.userInfo.tenant_id,
        patientName: this.patientInfo.patientName,
      });

      console.log(shareInfo.pageUrl);

      //小程序分享
      this.sendMsg(shareInfo.msgTitle, shareInfo.imgUrl, shareInfo.pageUrl);
    }, 1000),
    // 发送藩后街专属报告（无报告ID，走患者健康档案默认页面）
    onSendFanHouJieReport: tool._debouncefont(function () {
      //发送前检查是否有报告信息

      const user = userStore();

      // 检查患者是否有手机号码
      if (func.isEmpty(this.patientInfo.contactNo1)) {
        showToast("该患者无手机号码，请完善患者信息后再发送报告");
        return;
      }

      const clinic_id = user.userInfo.detail.clinic_id;
      const tenant_id = user.userInfo.tenant_id;

      if (!this.treatmentList || this.treatmentList.length === 0) {
        showToast("该患者没有口腔报告信息");
        return;
      }

      // 计算48小时后的时间戳
      const currentTime = Date.now();
      const expireTime = currentTime + this.MSG_VALID_TIME;

      // 对分享参数进行AES加密，保证分享链接的安全性
      // 构建分享参数对象，包含所有必要的信息
      const shareParams = {
        type: "patient", // 验证类型：患者分享
        patient_id: this.patientId, // 患者ID
        clinic_id: clinic_id, // 诊所ID
        tenant_id: tenant_id, // 租户ID
        expire_time: expireTime, // 过期时间戳
      };

      // 将参数对象转换为JSON字符串并使用AES加密
      const encryptedParams = crypto.encrypt(JSON.stringify(shareParams));

      //发给客户
      let shareInfo = {
        msgTitle: `${this.patientInfo.patientName}您好，点击查收您的健康档案`,
        imgUrl:
          "https://ygj-cdn-static.oss-cn-beijing.aliyuncs.com/scrm/images/home/da.png",
        pageUrl: `pages/healthRecords/shareVerification/shareVerification.html?data=${encodeURIComponent(
          encryptedParams,
        )}`,
      };

      console.log(shareInfo.pageUrl);

      //小程序分享
      this.sendMsg(shareInfo.msgTitle, shareInfo.imgUrl, shareInfo.pageUrl);
    }, 1000),
    // 发送小程序消息方法
    sendMsg(msgTitle, imgUrl, pageUrl) {
      let that = this;
      const user = userStore();

      let wxappid = user.wxAppId;

      if (func.isEmpty(wxappid)) {
        wxappid = getStore({ name: "wxAppId" });
      }

      if (func.isEmpty(wxappid)) {
        showDialog({
          title: "发送失败",
          message: "未获取到小程序AppId",
          confirmButtonColor: "#28B8C3",
        });
        return;
      }

      that.loading.showLoading();
      user
        .getWxconfig(["sendChatMessage"])
        .then(() => {
          const sendParams = {
            msgtype: "miniprogram",
            miniprogram: {
              appid: wxappid,
              title: msgTitle,
              imgUrl,
              page: pageUrl,
            },
          };
          const callback = function (res) {
            that.loading.hideLoading();
            if (res.err_msg == "sendChatMessage:ok") {
              //发送成功
              showToast("发送成功");
            }
          };

          // 橘子平台发送小程序消息需额外携带小程序原始 ID。
          if (isJuzi()) {
            const juziSend = useJuziSendStore();
            juziSend.sendMiniprogramMessage(sendParams, callback);
            return;
          }

          wx.invoke("sendChatMessage", sendParams, callback);
        })
        .catch((err) => {
          that.loading.hideLoading();
          showDialog({
            title: "发送失败",
            message: err,
            confirmButtonColor: "#28B8C3",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-push-container {
  font-size: 0.292rem;
  box-sizing: border-box;
  flex: 1;
  height: 0;
  text-align: left;

  .title-before {
    position: relative;
    padding-left: 0.25rem;
    color: #333;
    &::before {
      content: "";
      position: absolute;
      display: inline-block;
      left: 0;
      top: 0.042rem;
      height: 0.317rem;
      width: 0.083rem;
      border-radius: 20.813rem;
      background: rgb(40, 184, 195);
    }
  }

  .symptom-list {
    padding: 0 0.25rem;

    .no-data {
      text-align: center;
      padding: 0.5rem;
      color: #999;
      font-size: 0.292rem;
    }
  }

  .report-group {
    margin-top: 0.333rem;

    .report-group-title {
      font-weight: 500;
      font-size: 0.333rem;
      color: #333;
      margin-bottom: 0.083rem;
    }

    .report-group-entry {
      font-size: 0.25rem;
      color: #999;
      margin-bottom: 0.167rem;
    }

    .report-card {
      background: #fff;
      border-radius: 0.083rem;
      padding: 0.25rem;
      margin-bottom: 0.208rem;

      .report-card-row {
        line-height: 1.6;
        font-size: 0.271rem;
        color: #333;

        .report-card-label {
          color: #333;
        }

        .report-card-value {
          color: #333;
        }
      }

      .report-card-buttons {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 0.167rem;

        .report-card-btn {
          padding: 0.083rem 0.25rem;
          border-radius: 0.313rem;
          font-size: 0.271rem;
          color: #fff;
          cursor: pointer;
          text-align: center;

          &.btn-preview {
            background: #28b8c3;
            margin-right: 0.167rem;
          }

          &.btn-send {
            background: #28b8c3;
          }
        }
      }
    }
  }
}
</style>
